/* Load nearby reel posters and keep one homepage reel playing at a time. */
(() => {
  'use strict';
  if (customElements.get('effy-home-page')) return;

  class EffyHomePage extends HTMLElement {
    connectedCallback() {
      if (this.onVideoPlay) return;
      this.onVideoPlay = event => {
        if (!(event.target instanceof HTMLVideoElement)) return;
        this.loadPoster(event.target);
        this.querySelectorAll('video').forEach(video => {
          if (video !== event.target) video.pause();
        });
      };
      this.onVideoInteraction = event => {
        if (event.target instanceof HTMLVideoElement) this.loadPoster(event.target);
      };
      this.addEventListener('play', this.onVideoPlay, true);
      this.addEventListener('focusin', this.onVideoInteraction);
      this.addEventListener('pointerdown', this.onVideoInteraction, true);
      this.observePosters();
    }

    loadPoster(video) {
      const poster = video.getAttribute('data-effy-poster');
      if (!poster) return;
      video.setAttribute('poster', poster);
      video.removeAttribute('data-effy-poster');
      this.posterObserver?.unobserve(video);
    }

    observePosters() {
      const pending = [...this.querySelectorAll('video[data-effy-poster]')];
      if (!pending.length) return;
      if (typeof IntersectionObserver !== 'function') {
        pending.forEach(video => this.loadPoster(video));
        return;
      }
      try {
        const observer = new IntersectionObserver(entries => {
          if (this.posterObserver !== observer || !this.isConnected) return;
          entries.forEach(entry => {
            if (entry.isIntersecting) this.loadPoster(entry.target);
          });
        }, { rootMargin: '400px 0px', threshold: 0 });
        this.posterObserver = observer;
        pending.forEach(video => observer.observe(video));
      } catch {
        this.posterObserver?.disconnect();
        this.posterObserver = null;
        pending.forEach(video => this.loadPoster(video));
      }
    }

    disconnectedCallback() {
      this.posterObserver?.disconnect();
      this.posterObserver = null;
      this.querySelectorAll('video').forEach(video => video.pause());
      this.removeEventListener('play', this.onVideoPlay, true);
      this.removeEventListener('focusin', this.onVideoInteraction);
      this.removeEventListener('pointerdown', this.onVideoInteraction, true);
      this.onVideoPlay = null;
      this.onVideoInteraction = null;
    }
  }

  customElements.define('effy-home-page', EffyHomePage);
})();
